<div class="edit-container position-relative">
    <h1 class="edit-title">Actualizează drepturi acces Operator</h1>
    <div class="edit-card__form">
        <div class="edit-field">
            <p>Servicii > Tipuri Direcții</p>
        </div>

        <!-- <form [formGroup]="form">
            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Responsabil Proiect</mat-label>
                        <mat-select formControlName="responsabil">
                            <mat-option *ngFor="let row of selectOptions" [value]="row.id">
                                {{ row.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="!form.controls['responsabil'].valid && form.controls['responsabil'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Agent Teren</mat-label>
                        <mat-select formControlName="agent_teren">
                            <mat-option *ngFor="let row of selectOptions" [value]="row.id">
                                {{ row.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="!form.controls['agent_teren'].valid && form.controls['agent_teren'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <div class="pb-2">
            <mat-divider></mat-divider>
        </div> -->

        <div class="edit-field">
            <div *ngFor="let serviciu of functiiOperator$ | async" class="checkbox">
                <mat-checkbox color="primary" [(ngModel)]="serviciu.checked" (change)="updateCheckedList(serviciu)">
                    {{serviciu.name}}
                </mat-checkbox>
                <div *ngFor="let directie of serviciu.directii_types" class="checkbox subchild">
                    <mat-checkbox color="primary" [(ngModel)]="directie.checked"
                        (change)="updateCheckedList(directie, true)">
                        {{directie.name}}
                    </mat-checkbox>
                </div>
            </div>
        </div>

        <div class="pb-2">
            <mat-divider></mat-divider>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="button" mat-flat-button color="primary"
                    (click)="updatePermisiuniOperator()">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>